import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { paginateFunction } from "../Redux/actions";
const PaginationComp = () => {
  let dispatcher = useDispatch();
  let [pageCount, setPageCount] = useState(0);
  const handlePageClick = (data) => {
    // data = {selected: index starts with 0}
    // the initial value is : {selected : 0}
    dispatcher(paginateFunction(data.selected + 1));
  };
  // get the pageCount from the store
  let pages = useSelector((state) => state.pageCount);
  useEffect(() => {
    setPageCount(pages);
  }, []);
  return (
    <div>
      <ReactPaginate
        breakLabel="..."
        nextLabel="التالي"
        onPageChange={handlePageClick}
        pageRangeDisplayed={2}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="السابق"
        renderOnZeroPageCount={null}
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName=" d-flex align-items-center mt-3 justfiy-content-center pagination"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
        pageClassName="page-item"
        pageLinkClassName="page-link"
      />
    </div>
  );
};

export default PaginationComp;
